import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from '../config/config';
import translationHBL from './hbl/translation.json';
import translationSLG from './slg/translation.json';

declare module 'react-i18next' {
  interface Resources {
    translation: typeof translationHBL;
  }
}

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'configLanguageDetector',
  lookup: () => {
    return config.language;
  }
});

i18n.use(initReactI18next).use(languageDetector).init({
  resources: {
    hbl: {
      translation: translationHBL,
    },
    slg: {
      translation: translationSLG
    }
  },
  detection: {
    order: ['configLanguageDetector']
  }
});

export default i18n;
